import React, { useEffect, useState } from 'react';
import shopDot from '../../assets/images/logo.svg'
import poweredbyLogo from "../../assets/V2/svg/poweredby.svg";

import { Search, ShoppingCart, Star, Facebook, Twitter, Instagram } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useStore } from '../../context/StoreContext';
// import insta from "../../assets/images/icons/insta.svg"
import FacebookIcon from '../../assets/images/icons/FacebookIcon';
import InstaIcon from '../../assets/images/icons/InstaIcon';
import TwitterIcon from '../../assets/images/icons/TwitterIcon';
import axios from '../../utilities/axios';
import * as API_END_POINT from '../../utilities/constant';
import { toast } from 'react-toastify';
import YoutubeIcon from '../../assets/images/icons/YoutubeIcon';
import TiktokIcon from '../../assets/images/icons/TiktokIcon';
import AnimalIcon from '../../assets/images/icons/AnimalIcon';
import GlobeIcon from '../../assets/images/icons/GlobeIcon';
const IframeFooter = () => {
  const { storeDetails, pageDetails, error } = useStore();
  const navigate = useNavigate();
  useEffect(() => {
    // navigate('/store-not-available')
  }, [error])

  useEffect(() => {
    if (storeDetails?.store_name) {
      document.title = storeDetails?.store_name + ` 's Online Store`;
    }
  }, [storeDetails?.store_name]);
  const [email, setEmail] = useState('');
  const handleSubscribe = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        API_END_POINT.NEWSLETTER_SUBMIT,
        {
          email,
          subscription_source: 'footer',
        },
        {
          headers: {
            'store-domain': 'mango',
            'Content-Type': 'application/json',
          },
        }
      );
      const res = response?.data?.data;
      toast.success(res.message, { position: 'top-right' });
      setEmail(''); // clear field
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || 'Subscription failed', {
        position: 'top-right',
      });
    }
  };

  return (
    <footer className="bg-white py-4 px-3 md:px-4">
      <div className="max-w-7xl mx-auto">
     
          {/* Terms */}
          <div className='w-full'>
            {/* <h3 className="font-semibold text-gray-900 mb-4">Terms</h3> */}
            <ul className=" text-sm text-gray-600 flex gap-[20px] justify-center">
              <li><a href="https://legal.shopdotapp.com/shipping-and-returns-policy/" target="_blank" className="hover:text-gray-900">Shipping and Returns</a></li>
              {/* <li><a href="https://shopdotapp.com/privacy-policy/" target="_blank" className="hover:text-gray-900">Ordering Policy</a></li> */}
              <li><a href="https://legal.shopdotapp.com/retail-terms/" target="_blank" className="hover:text-gray-900">Terms of Service</a></li>
              <li><a href="https://legal.shopdotapp.com/privacy-policy/" target="_blank" className="hover:text-gray-900">Privacy Policy</a></li>
            </ul>
          </div>

          {/* Stay Connected */}
      
      
      </div>
    </footer>
  );
};

export default IframeFooter;